import React, { useEffect, useState } from "react";

export function DateValidator() {
	const [dateInfo, setDateInfo] = useState<{
		currentDate: string;
		isoString: string;
		year: number;
		isValidYear: boolean;
	} | null>(null);

	useEffect(() => {
		const now = new Date();
		const year = now.getFullYear();

		setDateInfo({
			currentDate: now.toLocaleString(),
			isoString: now.toISOString(),
			year: year,
			isValidYear: year >= 2020 && year <= 2030,
		});
	}, []);

	// Only show in development and if there's a date issue
	if (
		process.env.NODE_ENV !== "development" ||
		!dateInfo ||
		dateInfo.isValidYear
	) {
		return null;
	}

	return (
		<div className="fixed top-4 left-4 bg-red-100 border-2 border-red-500 text-red-800 p-4 rounded-lg max-w-md z-50">
			<div className="font-bold mb-2">⚠️ INVALID SYSTEM DATE DETECTED</div>
			<div className="text-sm space-y-1">
				<div>Current Date: {dateInfo.currentDate}</div>
				<div>ISO String: {dateInfo.isoString}</div>
				<div>Year: {dateInfo.year}</div>
				<div className="font-semibold text-red-900 mt-2">
					System clock appears to be incorrect. This may cause 406 errors.
				</div>
			</div>
		</div>
	);
}
